import CONSTANTS from '../constants';
import { alerts } from './alerts';
import UserService from '../services/userService';

export function fetchTrainers(skipAuth = false, businessName = null) {
    return dispatch => {
        return UserService.getTrainers(skipAuth, businessName).then((response) => {
            dispatch(trainerAction(response.data));
        }).catch(() => {
            dispatch(alerts.error('Trainers not found'));
        });
    };

    function trainerAction(trainers) { return {type: CONSTANTS.ACTIONS.USER.GET.TRAINERS, trainers: trainers} }
}

export function fetchBusinessHours(trainerId, date) {
    return dispatch => {
        return UserService.getBusinessHours(trainerId, date).then((response) => {
            dispatch(businessHoursActions(response.data));
        }).catch(() => {
            dispatch(alerts.error('Business hours not found'));
        });
    };

    function businessHoursActions(businessHours) { return {type: CONSTANTS.ACTIONS.USER.GET.BUSINESS_HOURS, businessHours: businessHours} }
}



// WEBPACK FOOTER //
// ./src/actions/users.js